import { render, staticRenderFns } from "./MediaOrientationCheck.vue?vue&type=template&id=496ac1aa"
import script from "./MediaOrientationCheck.vue?vue&type=script&lang=js"
export * from "./MediaOrientationCheck.vue?vue&type=script&lang=js"
import style0 from "./MediaOrientationCheck.vue?vue&type=style&index=0&id=496ac1aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports